<template>

    <section>
        <!-- トリガー要素 ここから -->
            <!-- BtnLinkWrap -->
            <div class="btn_link-wrap">

                <!--LinkBtn-->
                <button class="btn_link _cancel md_icon-text" data-modal="DeleteConf">
                    <div class="inner">
                        <span><div class="icon"><SvgIconCancel /></div>削除用モーダルを開く</span>
                    </div>
                </button>

                <!--LinkBtn-->
                <button class="btn_link md_icon-text _white" data-modal="ModalValidation">
                    <div class="inner">
                        <span><div class="icon"><SvgIconCheck /></div>正しく入力してくださいモーダルを開く</span>
                    </div>
                </button>

            </div><!-- /.BtnLinkWrap -->
        <!-- トリガー要素 ここまで -->


        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            ModalDelete
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="modal_container _delete DeleteConf">
            <div class="modal_wrap">

                <!-- Title -->
                <div class="modal_title">
                    <h3><span>削除しますか？</span></h3>
                </div>

                <!-- Body -->
                <div class="modal_body">
                    <div class="inner">
                        <p>
                            <span class="md_text-bold _link-color">hogehoge</span> を削除しようとしています。本当に削除してよろしいですか？
                        </p>
                    </div>
                </div>

                <!--btn-link-wrap-->
                <div class="btn_link-wrap">

                    <button class="btn_link _cancel md_icon-text js-modal-close">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                        </div>
                    </button>

                    <button class="btn_link md_icon-text _white _delete js-modal-close">
                        <div class="inner">
                            <span><div class="icon"><SvgIconDelete /></div>削除する</span>
                        </div>
                    </button>

                </div><!--/.btn-link-wrap-->

            </div>
            <div class="modal_close-ovl js-modal-close"></div>
        </div>

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            ModalValidation
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="modal_container _delete ModalValidation">
            <div class="modal_wrap">

                <!-- Title -->
                <div class="modal_title">
                    <h3><span>正しく入力してください</span></h3>
                </div>

                <!-- Body -->
                <div class="modal_body">
                    <div class="inner">
                        <p>入力内容に誤りがあるようです。ご確認の上、正しく入力してください。</p>
                    </div>
                </div>

                <!--btn-link-wrap-->
                <div class="btn_link-wrap">

                    <button class="btn_link md_icon-text _white js-modal-close">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>OK</span>
                        </div>
                    </button>

                </div><!--/.btn-link-wrap-->

            </div>
            <div class="modal_close-ovl js-modal-close"></div>
        </div>

    </section>

</template>


<script>

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'

    export default {
        components: {
            //Svg
            SvgIconCheck,
            SvgIconCancel,
            SvgIconDelete
        },
        mounted() {
            ////////////////////////////////////
            //モーダル開閉
            ////////////////////////////////////
            $('[data-modal]').click(function (e) {
            var target = $(e.target);
            var targetModalSelector = target.attr('data-modal'); //data-modalの値を代入する
            if (!targetModalSelector) {
                targetModalSelector = target.parents('[data-modal]').attr('data-modal');
            }
                $('.modal_container.' + targetModalSelector).addClass('_open'); //class="modal_container data-modalの値" を持つ要素をターゲットとし、class="_open"を付与。
                $('.modal_bg').addClass('_on'); //背景要素にも _on を付けて表示させる。_on のスタイルはcssで定義しておく。
            });

            //CLOSE
            $('.js-modal-close').click(function (e) { //このclassをクリックすると、表示中のモーダルウィンドウからヘルパークラスを取り非表示にする。
                $('.modal_container').removeClass('_open');
                $('.modal_bg').removeClass('_on');
            });
        }
    }
</script>